import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPurchaseOrderBulkResponse,
  IInventoryPurchaseOrderBulkUpload,
} from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

export const useInventoryPurchaseOrderBulkUploadAPI = () => {
  const configuration = useConfiguration();
  const { enable, disable } = useLoaderActions("isBulkUploadInProgress");
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (data: IInventoryPurchaseOrderBulkUpload) => {
      enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IInventoryPurchaseOrderBulkResponse = await axios
          .post(`${INVENTORY_MODULE?.PURCHASE_ORDER_BULK_UPLOAD?.baseURL}`, data, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res: AxiosResponse<IInventoryPurchaseOrderBulkResponse>) => {
            disable();
            if (res.data.status) {
              toast.success("Bulk upload successfully");
            } else {
              toast.error("Bulk upload failed ");
            }
            return res.data;
          })
          .catch((e: AxiosError) => {
            disable();
            if (e.response?.status === 422) {
              return e.response.data as IInventoryPurchaseOrderBulkResponse; // Return error response
            }
            captureError(e);
            return e.response.data as IInventoryPurchaseOrderBulkResponse;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return null;
      }
    },
    [dispatch],
  );
  return execute;
};
